import { z, isoZ } from 'my-zod'

export const ActionPlanTemplateStatusEnum = z.enum(['Archived'])
export const ActionPlanTaskUserAssigneeTypeEnum = z
  .enum(['ActionPlanOwner', 'AccountSpecialist', 'RiskSpecialist', 'AdventuresFleetManager', 'ServiceOps'])
  .setEnumLabels({
    ActionPlanOwner: 'Action Plan Owner',
    AccountSpecialist: 'Account Manager',
    RiskSpecialist: 'Risk Specialist',
    AdventuresFleetManager: 'Adventures Fleet Manager',
    ServiceOps: 'Service Ops'
  })

export type ActionPlanTaskUserAssigneeType = z.infer<typeof ActionPlanTaskUserAssigneeTypeEnum>

export const actionPlanTemplateTaskModel = z.object({
  id: z.number(),
  groupId: z.number(),
  actionPlanTemplateId: z.number(),
  orderInGroup: z.number(),
  title: z.string().nonempty(),
  dueDateEndingPattern: z.string().nonempty(),
  userAssigneeType: ActionPlanTaskUserAssigneeTypeEnum,
  lastModifiedDate: isoZ.instant().nullable(),
  createdDate: isoZ.instant(),
  deletedDate: isoZ.instant().nullable()
})

export type actionPlanTemplateTaskModel = z.infer<typeof actionPlanTemplateTaskModel>

export const actionPlanTemplateTaskGroupModel = z.object({
  id: z.number(),
  actionPlanTemplateId: z.number(),
  orderInTemplate: z.number(),
  title: z.string().nullable().setLabel('Task Group'),
  templateTasks: actionPlanTemplateTaskModel.array(),
  lastModifiedDate: isoZ.instant().nullable(),
  createdDate: isoZ.instant(),
  deletedDate: isoZ.instant().nullable()
})

export type actionPlanTemplateTaskGroupModel = z.infer<typeof actionPlanTemplateTaskGroupModel>

export const actionPlanTemplateModel = z.object({
  id: z.number(),
  shortId: z.string(),
  title: z.string().nonempty().setLabel('Action Plan Name'),
  description: z.string().nonempty(),
  status: ActionPlanTemplateStatusEnum.nullable(),
  creatingUserId: z.number(),
  dueDateEndingPattern: z.string().nonempty(),
  templateTaskGroups: actionPlanTemplateTaskGroupModel.array(),
  lastModifiedDate: isoZ.instant().nullable(),
  createdDate: isoZ.instant(),
  deletedDate: isoZ.instant().nullable()
})

export type actionPlanTemplateModel = z.infer<typeof actionPlanTemplateModel>
